import { PageHeader } from "@shared/components/PageHeader";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { Card } from "@shared/ui/card";
import { Tabs } from "@shared/ui/tabs";

import RecipientListDetails from "../recipientListDetails/recipientListDetails";
import QuickAction from "../QuickAction/quickAction";
import UsageHistoryLanding from "../tabs/usageHistory/landing/landing";
import Memberslanding from "../tabs/members/landing/landing";

import { useGetRecipientDetails } from "../../hooks";
import { NotesTab } from "@features/ux/components/shared/components/notesTab";
import { ActivityLogTab } from "@features/ax/shared/ActivityLog";

const RecipientListDetailsLanding = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: listData } = useGetRecipientDetails(Number(id));
  return (
    <div>
      <div className="flex items-center gap-4">
        <ArrowLeft
          className="w-5 h-5 cursor-pointer text-gray-700 hover:text-gray-900"
          onClick={() => navigate("/communication-hub/recipient-list")}
        />
        <div className="flex flex-col">
          <PageHeader
            title="View Recipient List"
            subtitle="Preview and verify your recipient list content"
          />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
        <Card className="col-span-8 mt-4">
          <RecipientListDetails data={listData} />
        </Card>
        <Card className="col-span-4 mt-4">
          <QuickAction data={listData} />
        </Card>
      </div>
      <div className="flex flex-col space-y-4 mt-3">
        <div className="w-full overflow-hidden">
          <Tabs
            defaultValue="usageHistory"
            className="w-full"
            tabsListClassName="grid w-full grid-cols-4 mb-6 p-1"
            urlMapping={{
              usageHistory: "usageHistory",
              members: "members",
              notes: "notes",
              activityLog: "activityLog",
            }}
            tabComponents={{
              usageHistory: {
                label: "Usage History",
                component: <UsageHistoryLanding />,
              },
              members: {
                label: "Members",
                component: <Memberslanding />,
              },
              notes: {
                label: "Notes",
                component: (
                  <NotesTab
                    requestId={id}
                    source="2"
                  />
                ),
              },
              activityLog: {
                label: "Activity Log",
                component: <ActivityLogTab entityId={id} entityType="2" />,
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default RecipientListDetailsLanding;
